import React from "react";
import { useTranslation } from "react-i18next";
import ToothFairySlider from "../../../../Components/ToothFairyComponents/ToothFairySlider";
import useWorkspaces from "../../../../Hooks/useWorkspaces";

const PreferencesGPT = ({
  handleUpdate,
  isWorkspaceSetting,
  isQA,
  temperatureProperty,
  topPProperty,
  frequencyPenaltyProperty,
  presencePenaltyProperty,
  maxTokensProperty,
  TopKProperty,
  step = 50,
}) => {
  const { t } = useTranslation();
  const { getActiveWorkspace, getContentMultiplier } = useWorkspaces();
  return (
    <>
      <ToothFairySlider
        minimumValue={0.1}
        maximumValue={1}
        step={0.1}
        label={t("settings.preferences.temperature")}
        onSubmit={(v) => {
          handleUpdate("parsingConfig", {
            ...getActiveWorkspace().parsingConfig,
            [temperatureProperty]: v,
          });
        }}
        initialValue={getActiveWorkspace()?.parsingConfig[temperatureProperty]}
      />
      <ToothFairySlider
        label={t("settings.preferences.topP")}
        minimumValue={0.1}
        maximumValue={1}
        step={0.1}
        onSubmit={(v) =>
          handleUpdate("parsingConfig", {
            ...getActiveWorkspace().parsingConfig,
            [topPProperty]: v,
          })
        }
        initialValue={getActiveWorkspace()?.parsingConfig[topPProperty]}
      />
      <ToothFairySlider
        label={t("settings.preferences.frequencyPenalty")}
        minimumValue={0.1}
        maximumValue={1}
        step={0.1}
        onSubmit={(v) =>
          handleUpdate("parsingConfig", {
            ...getActiveWorkspace().parsingConfig,
            [frequencyPenaltyProperty]: v,
          })
        }
        initialValue={
          getActiveWorkspace()?.parsingConfig[frequencyPenaltyProperty]
        }
      />
      <ToothFairySlider
        label={t("settings.preferences.presencePenalty")}
        minimumValue={0.1}
        maximumValue={1}
        step={0.1}
        onSubmit={(v) =>
          handleUpdate("parsingConfig", {
            ...getActiveWorkspace().parsingConfig,
            [presencePenaltyProperty]: v,
          })
        }
        initialValue={
          getActiveWorkspace()?.parsingConfig[presencePenaltyProperty]
        }
      />
      <ToothFairySlider
        label={t("settings.preferences.maxTokens")}
        minimumValue={isQA ? 50 : 300}
        maximumValue={(isQA ? 200 : 2000) * getContentMultiplier()}
        step={step}
        onSubmit={(v) =>
          handleUpdate("parsingConfig", {
            ...getActiveWorkspace().parsingConfig,
            [maxTokensProperty]: v,
          })
        }
        initialValue={getActiveWorkspace()?.parsingConfig[maxTokensProperty]}
      />
      {isQA && (
        <ToothFairySlider
          label={t("settings.preferences.topK")}
          minimumValue={1}
          maximumValue={20}
          step={1}
          onSubmit={(v) =>
            handleUpdate("parsingConfig", {
              ...getActiveWorkspace().parsingConfig,
              [TopKProperty]: v,
            })
          }
          initialValue={getActiveWorkspace()?.parsingConfig[TopKProperty]}
        />
      )}
    </>
  );
};

export default PreferencesGPT;
